import gql from "graphql-tag"

export const CREATE_MEDIA_FOLDER = gql`
  mutation createMediaFolder($siteId: Int!, $name: String!) {
    createMediaFolder(input: { siteId: $siteId, name: $name }) {
      success
      error
      mediaFolder {
        id
        name
        siteId
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_MEDIA_FOLDER = gql`
  mutation updateMediaFolder($id: Int!, $name: String!) {
    updateMediaFolder(input: { id: $id, name: $name }) {
      success
      error
      mediaFolder {
        id
        name
        siteId
        createdAt
        updatedAt
      }
    }
  }
`